module.exports = __webpack_public_path__ + "img/joinus.2319a51e.png";